import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/login";
// const regsiterApiEndpoint = API_BASE_URL_ENV() + "/admin-module-api/register";
const ProfileApiEndpoint = API_BASE_URL_ENV() + "/admin/user/profile";
export const tokenKey = "vr_token";

http.setJwt(getJwt());

export async function login(credentials) {
	const { data: userData } = await http.post(apiEndpoint, credentials);
	if (userData?.status === 200) {
		localStorage.setItem(tokenKey, userData?.data?.accessToken);
		localStorage.setItem(
			"vr_auth",
			JSON.stringify({
				...userData?.data?.admin,
				token: userData?.data?.accessToken,
				userType: "admin",
			}),
		);
	}
	return userData;
}

export async function forgetPassword(url, params) {
	const { data: userData } = await http.post(url, params);
	if (userData?.access_token) {
		localStorage.setItem(tokenKey, userData.access_token);
		localStorage.setItem(
			"vr_auth",
			JSON.stringify({ ...userData, userType: "admin" }),
		);
	}
	return userData;
}

export async function resetPassword(url, params) {
	const { data: userData } = await http.post(url, params);
	return userData;
}
export async function changePassword(url, params) {
	const { data: userData } = await http.post(url, params);
	return userData;
}

export function loginWithJwt(jwt) {
	localStorage.setItem(tokenKey, jwt);
}

export function logout() {
	localStorage.removeItem(tokenKey);
	localStorage.removeItem("vr_auth");
}

export async function getCurrentUser() {
	try {
		http.setJwt(getJwt());
		// const jwt = localStorage.getItem(tokenKey);
		const { data: userData } = await http.get(ProfileApiEndpoint);
		return userData;
		// return jwtDecode(jwt);
	} catch (ex) {
		return null;
	}
}

export function isAuthenticated() {
	return localStorage.getItem(tokenKey) ? true : false;
}

export function getJwt() {
	return localStorage.getItem(tokenKey);
}

export default {
	login,
	loginWithJwt,
	logout,
	getCurrentUser,
	getJwt,
	isAuthenticated,
	resetPassword,
	changePassword,
	// register,
	forgetPassword,
};
